import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=423a01ca&"
import script from "./MainNav.vue?vue&type=script&lang=js&"
export * from "./MainNav.vue?vue&type=script&lang=js&"
import style0 from "./MainNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports